import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsTerminalBlocksIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-terminal-blocks',
  templateUrl: './ds-terminal-blocks.component.html',
  styleUrls: ['./ds-terminal-blocks.component.css']
})
export class DsTerminalBlocksComponent implements OnInit, OnChanges {
  
    @Input() dsTerminalBlocksObj: DsTerminalBlocksIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
        this.inputDisableMessage = "You don't have EDIT ACCESS.";
      }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsTerminalBlocksObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }

  termBlockMakeChange() {
  this.typeOfTermDiscChange(this.dsTerminalBlocksObj.typeOfTermDisc);
  this.typeOfTermNonDiscChange(this.dsTerminalBlocksObj.typeOfTermNonDisc);
  }
   
  typeOfTermDiscChange(_selectedVal: string) {
  let _make = this.dsTerminalBlocksObj.termBlockMake;
  let _typTerm = _selectedVal;
  switch (_make) {
    case "001": // Elmex
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.currTrnfCirc = "KLTDM4NV";
        this.dsTerminalBlocksObj.potentTrnfCirc = "KLTDM4NV";
      }
      break;
    case "002": // Connectwell
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.currTrnfCirc = "CBDT4UNS";
        this.dsTerminalBlocksObj.potentTrnfCirc = "CBDT4UNS";
      }
      break;
    case "003": // Phoenix
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.currTrnfCirc = "RBO 5-T-E";
        this.dsTerminalBlocksObj.potentTrnfCirc = "RBO 5-T-E";
      }
      break;
    }
  }

  typeOfTermNonDiscChange(_selectedVal: string) {
  let _make = this.dsTerminalBlocksObj.termBlockMake;
  let _typTerm = _selectedVal;
  switch (_make) {
    case "001": // Elmex
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.termBlockContCirc = "KATM3";
      }
      else if (_typTerm == "002") { // Screw
        this.dsTerminalBlocksObj.termBlockContCirc = "KUT2.5";
      }
      else if (_typTerm == "003") { // Spring
        this.dsTerminalBlocksObj.termBlockContCirc = "DCT2.5-2X2";
      }
      break;
    case "002": // Connectwell
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.termBlockContCirc = "CSB3/N3UL";
      }
      else if (_typTerm == "002") { // Screw
        this.dsTerminalBlocksObj.termBlockContCirc = "CTS2.5UE";
      }
      else if (_typTerm == "003") { // Spring
        this.dsTerminalBlocksObj.termBlockContCirc = "AS2.5/4";
      }
      break;
    case "003": // Phoenix
    if (_typTerm == "001") { // Stud
        this.dsTerminalBlocksObj.termBlockContCirc = "RBO 3/SP/SP E";
      }
      else if (_typTerm == "002") { // Screw
        this.dsTerminalBlocksObj.termBlockContCirc = "TB 4 EI";
      }
      else if (_typTerm == "003") { // Spring
        this.dsTerminalBlocksObj.termBlockContCirc = "STS 2,5-QUATTRO";
      }
      break;
    }
  }

 sectionNoteChangePM(_event: any) {
    this.dsTerminalBlocksObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsTerminalBlocksObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsTerminalBlocksObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Make", !!this.dsTerminalBlocksObj.termBlockMake, " required to save Datasheet."),
        new ValidationItem("Type of Terminal (Disconnecting)", !!this.dsTerminalBlocksObj.typeOfTermDisc, " required to save Datasheet."),
        new ValidationItem("Type of Terminal (Non-Disconnecting)", !!this.dsTerminalBlocksObj.typeOfTermNonDisc, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsTerminalBlocksObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsTerminalBlocksObj.isTermBlockMakeSpecReqApplicable) {
        _validList.push(new ValidationItem("Make Detail", !!this.dsTerminalBlocksObj.termBlockMakeDetail, " required to save Datasheet."));
      }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsTerminalBlocksObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsTerminalBlocksObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsTerminalBlocksObj.termBlockMake || !this.dsTerminalBlocksObj.typeOfTermDisc ||
        !this.dsTerminalBlocksObj.typeOfTermNonDisc || !this.dsTerminalBlocksObj.sectionNoteEE) {
        return false;
      }
      if (this.dsTerminalBlocksObj.isTermBlockMakeSpecReqApplicable) {
        if (!this.dsTerminalBlocksObj.termBlockMakeDetail) return false;
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsTerminalBlocksObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsTerminalBlocksObj.sectionNoteME) return false;
    }
    return true;
  }

}
